// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3E%3Cpath fill=%27%236b7280%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 20px;
  box-sizing: border-box;
}

.status-display {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 15px 0;
}
.status-display.cancelled-status {
  border-left: 4px solid #dc3545;
  background: #fff5f5;
}
.status-display .status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  margin-left: 8px;
}
.status-display .status-badge.cancelled {
  background: #dc3545;
  color: white;
}
.status-display .status-note {
  margin: 8px 0 0 0;
  font-size: 14px;
  color: #666;
  font-style: italic;
}

.cancellation-remark-section {
  margin: 15px 0;
  padding: 15px;
  background: #fff8f0;
  border-left: 4px solid #ff9800;
  border-radius: 4px;
}
.cancellation-remark-section label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}
.cancellation-remark-section .cancellation-remark-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  min-height: 60px;
  box-sizing: border-box;
}
.cancellation-remark-section .cancellation-remark-textarea:focus {
  outline: none;
  border-color: #ff9800;
  box-shadow: 0 0 0 2px rgba(255, 152, 0, 0.1);
}
.cancellation-remark-section .cancellation-remark-textarea::placeholder {
  color: #888;
}

.cancellation-remark-display {
  margin-top: 15px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
}
.cancellation-remark-display strong {
  color: #495057;
  font-size: 14px;
  display: block;
  margin-bottom: 8px;
}
.cancellation-remark-display .remark-text {
  margin: 0;
  color: #6c757d;
  font-size: 13px;
  line-height: 1.4;
  background: white;
  padding: 8px 12px;
  border-radius: 3px;
  border: 1px solid #e9ecef;
}
.cancellation-remark-display .remark-text.no-remark {
  font-style: italic;
  color: #adb5bd;
}

.confirmation-modal {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  width: 700px;
  max-width: 95%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow-y: auto;
  gap: 20px;
  border: 1px solid #e5e7eb;
  position: relative;
}
.confirmation-modal.notinvoice {
  width: 420px;
}
.confirmation-modal.notinvoice .branch-form-close-button {
  top: 12px;
  right: 12px;
}
.confirmation-modal::-webkit-scrollbar {
  width: 6px;
}
.confirmation-modal::-webkit-scrollbar-track {
  background: #f3f4f6;
}
.confirmation-modal::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}
.confirmation-modal > p {
  font-size: 18px;
  color: #1f2937;
  margin: 0;
  line-height: 1.5;
  font-weight: 600;
  text-align: center;
}
.confirmation-modal .notinvoicep {
  text-align: left;
}
.confirmation-modal .status-select {
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  font-weight: 500;
  appearance: none;
  background: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s ease;
  color: #374151;
}
.confirmation-modal .status-select:hover {
  border-color: #6b7280;
}
.confirmation-modal .status-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.payment-section {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.payment-section .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 6px;
  margin: 0;
}
.payment-section .amount-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #374151;
  background: #f9fafb;
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 600;
  border: 1px solid #e5e7eb;
}
.payment-section .amount-info > div {
  display: flex;
  align-items: center;
  gap: 4px;
}
.payment-section .amount-info > div strong {
  color: #1f2937;
}
.payment-section .previous-payments {
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.payment-section .previous-payments h4 {
  margin: 0 0 12px 0;
  padding: 12px 16px 0;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
}
.payment-section .previous-payments .payments-table-container {
  max-height: 200px;
  overflow-y: auto;
  margin: 0 16px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
}
.payment-section .previous-payments .payments-table-container::-webkit-scrollbar {
  width: 4px;
}
.payment-section .previous-payments .payments-table-container::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 2px;
}
.payment-section .previous-payments .payments-table-container::-webkit-scrollbar-track {
  background: #f3f4f6;
}
.payment-section .previous-payments .payments-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin: 0;
}
.payment-section .previous-payments .payments-table th, .payment-section .previous-payments .payments-table td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
}
.payment-section .previous-payments .payments-table th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
  position: sticky;
  top: 0;
  z-index: 1;
  font-size: 11px;
}
.payment-section .previous-payments .payments-table td {
  color: #6b7280;
  background-color: white;
  font-weight: 500;
}
.payment-section .previous-payments .payments-table tr:hover td {
  background: #f9fafb;
}
.payment-section .previous-payments .payments-table tr:last-child td {
  border-bottom: none;
}
.payment-section .previous-payments .payments-table .download-receipt-btn {
  background: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}
.payment-section .previous-payments .payments-table .download-receipt-btn:hover {
  background: #059669;
}
.payment-section .previous-payments .payments-table .download-receipt-btn:active {
  background: #047857;
}
.payment-section .previous-payments .payments-table th:nth-child(1), .payment-section .previous-payments .payments-table td:nth-child(1) {
  width: 15%;
}
.payment-section .previous-payments .payments-table th:nth-child(2), .payment-section .previous-payments .payments-table td:nth-child(2) {
  width: 15%;
}
.payment-section .previous-payments .payments-table th:nth-child(3), .payment-section .previous-payments .payments-table td:nth-child(3) {
  width: 12%;
}
.payment-section .previous-payments .payments-table th:nth-child(4), .payment-section .previous-payments .payments-table td:nth-child(4) {
  width: 15%;
}
.payment-section .previous-payments .payments-table th:nth-child(5), .payment-section .previous-payments .payments-table td:nth-child(5) {
  width: 15%;
}
.payment-section .previous-payments .payments-table th:nth-child(6), .payment-section .previous-payments .payments-table td:nth-child(6) {
  width: 20%;
}
.payment-section .previous-payments .payments-table th:nth-child(7), .payment-section .previous-payments .payments-table td:nth-child(7) {
  width: 8%;
  text-align: center;
}
.payment-section .new-payment-form {
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.payment-section .new-payment-form h4 {
  margin: 0 0 16px 0;
  padding: 16px 16px 0;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
}
.payment-section .new-payment-form .payment-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  padding: 0 16px 16px;
}
.payment-section .new-payment-form .payment-row .pay-form-group {
  display: flex;
  flex-direction: column;
}
.payment-section .new-payment-form .payment-row .pay-form-group label {
  font-size: 12px;
  color: #374151;
  margin-bottom: 4px;
  font-weight: 600;
}
.payment-section .new-payment-form .payment-row .pay-form-group select,
.payment-section .new-payment-form .payment-row .pay-form-group input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
  background: #ffffff;
  color: #374151;
}
.payment-section .new-payment-form .payment-row .pay-form-group select:hover,
.payment-section .new-payment-form .payment-row .pay-form-group input:hover {
  border-color: #6b7280;
}
.payment-section .new-payment-form .payment-row .pay-form-group select:focus,
.payment-section .new-payment-form .payment-row .pay-form-group input:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.payment-section .new-payment-form .payment-row .pay-form-group select:disabled,
.payment-section .new-payment-form .payment-row .pay-form-group input:disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}
.payment-section .new-payment-form .payment-row .pay-form-group select::placeholder,
.payment-section .new-payment-form .payment-row .pay-form-group input::placeholder {
  color: #9ca3af;
}
.payment-section .new-payment-form .payment-row .pay-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  cursor: pointer;
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}
.confirmation-actions.notinvoice {
  border-top: none;
}
.confirmation-actions .confirm-btn,
.confirmation-actions .cancel-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.confirmation-actions .confirm-btn {
  background: var(--primary-color);
  color: white;
}
.confirmation-actions .confirm-btn:hover {
  background: var(--primary-color);
}
.confirmation-actions .cancel-btn {
  background: #6b7280;
  color: white;
}
.confirmation-actions .cancel-btn:hover {
  background: #4b5563;
}
.confirmation-actions .cancel-btn:active {
  background: #374151;
}

@media (max-width: 768px) {
  .confirmation-modal {
    width: 95%;
    padding: 20px;
    gap: 16px;
  }
  .confirmation-modal > p {
    font-size: 16px;
  }
  .confirmation-modal .payment-section {
    gap: 14px;
  }
  .confirmation-modal .payment-section .amount-info {
    flex-direction: column;
    gap: 4px;
    text-align: center;
    font-size: 13px;
  }
  .confirmation-modal .payment-section .previous-payments .payments-table {
    font-size: 10px;
  }
  .confirmation-modal .payment-section .previous-payments .payments-table th, .confirmation-modal .payment-section .previous-payments .payments-table td {
    padding: 6px 4px;
  }
  .confirmation-modal .payment-section .previous-payments .payments-table .download-receipt-btn {
    padding: 3px 6px;
    font-size: 9px;
  }
  .confirmation-modal .payment-section .new-payment-form .payment-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .confirmation-modal .payment-section .new-payment-form .payment-row .pay-form-group select,
  .confirmation-modal .payment-section .new-payment-form .payment-row .pay-form-group input {
    padding: 10px 12px;
    font-size: 14px;
  }
  .confirmation-modal .confirmation-actions .confirm-btn,
  .confirmation-modal .confirmation-actions .cancel-btn {
    flex: 1 1;
    padding: 12px 16px;
  }
}
.branch-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.branch-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.branch-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/ConfirmModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAAF;AAEE;EACE,8BAAA;EACA,mBAAA;AAAJ;AAGE;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AADJ;AAGI;EACE,mBAAA;EACA,YAAA;AADN;AAKE;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAHJ;;AAQA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AALF;AAOE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AALJ;AAQE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AANJ;AAQI;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AANN;AASI;EACE,WAAA;AAPN;;AAcA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAXF;AAaE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAXJ;AAcE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAZJ;AAcI;EACE,kBAAA;EACA,cAAA;AAZN;;AAiBA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AAdF;AAgBE;EACI,YAAA;AAdN;AAgBM;EACE,SAAA;EACF,WAAA;AAdN;AAkBE;EACE,UAAA;AAhBJ;AAmBE;EACE,mBAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAnBJ;AAsBG;EACG,gBAAA;AApBN;AAuBE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;EACA,cAAA;AArBJ;AAuBI;EACE,qBAAA;AArBN;AAwBI;EACE,qBAAA;EACA,6CAAA;AAtBN;;AA2BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxBF;AA0BE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,SAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAzBJ;AA2BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAzBN;AA2BM;EACE,cAAA;AAzBR;AA8BE;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;AA5BJ;AA8BI;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA5BN;AA+BI;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AA7BN;AA+BM;EACE,UAAA;AA7BR;AAgCM;EACE,mBAAA;EACA,kBAAA;AA9BR;AAiCM;EACE,mBAAA;AA/BR;AAmCI;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AAjCN;AAmCM;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;AAjCR;AAoCM;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;AAlCR;AAqCM;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;AAnCR;AAsCM;EACE,mBAAA;AApCR;AAuCM;EACE,mBAAA;AArCR;AAwCM;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;AAtCR;AAwCQ;EACE,mBAAA;AAtCV;AAyCQ;EACE,mBAAA;AAvCV;AA2CM;EAAmC,UAAA;AAxCzC;AAyCM;EAAmC,UAAA;AAtCzC;AAuCM;EAAmC,UAAA;AApCzC;AAqCM;EAAmC,UAAA;AAlCzC;AAmCM;EAAmC,UAAA;AAhCzC;AAiCM;EAAmC,UAAA;AA9BzC;AA+BM;EACE,SAAA;EACA,kBAAA;AA7BR;AAkCE;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;AAhCJ;AAkCI;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAhCN;AAmCI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,oBAAA;AAjCN;AAmCM;EACE,aAAA;EACA,sBAAA;AAjCR;AAmCQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAjCV;AAoCQ;;EAEE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,cAAA;AAlCV;AAoCU;;EACE,qBAAA;AAjCZ;AAoCU;;EACE,qBAAA;EACA,aAAA;EACA,6CAAA;AAjCZ;AAoCU;;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;AAjCZ;AAoCU;;EACE,cAAA;AAjCZ;AAqCQ;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,qCAAA;EACA,qBAAA;EACA,eAAA;AAnCV;;AA0CA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAvCF;AAyCE;EACE,gBAAA;AAvCJ;AA0CE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAxCJ;AA2CE;EACE,gCAAA;EACA,YAAA;AAzCJ;AA2CI;EACE,gCAAA;AAzCN;AA8CE;EACE,mBAAA;EACA,YAAA;AA5CJ;AA8CI;EACE,mBAAA;AA5CN;AA+CI;EACE,mBAAA;AA7CN;;AAmDA;EACE;IACE,UAAA;IACA,aAAA;IACA,SAAA;EAhDF;EAkDE;IACE,eAAA;EAhDJ;EAmDE;IACE,SAAA;EAjDJ;EAmDI;IACE,sBAAA;IACA,QAAA;IACA,kBAAA;IACA,eAAA;EAjDN;EAoDI;IACE,eAAA;EAlDN;EAoDM;IACE,gBAAA;EAlDR;EAqDM;IACE,gBAAA;IACA,cAAA;EAnDR;EAuDI;IACE,0BAAA;IACA,SAAA;EArDN;EAwDQ;;IAEE,kBAAA;IACA,eAAA;EAtDV;EA6DI;;IAEE,SAAA;IACA,kBAAA;EA3DN;AACF;AAgEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AA9DJ;AAgEI;EACE,yBAAA;EACA,cAAA;AA9DN;AAiEI;EACE,aAAA;EACA,6CAAA;AA/DN","sourcesContent":[".confirmation-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n  padding: 20px;\n  box-sizing: border-box;\n}\n// ADD this CSS to your ConfirmModal.scss file:\n\n.status-display {\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin: 15px 0;\n  \n  &.cancelled-status {\n    border-left: 4px solid #dc3545;\n    background: #fff5f5;\n  }\n  \n  .status-badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    margin-left: 8px;\n    \n    &.cancelled {\n      background: #dc3545;\n      color: white;\n    }\n  }\n  \n  .status-note {\n    margin: 8px 0 0 0;\n    font-size: 14px;\n    color: #666;\n    font-style: italic;\n  }\n}\n\n// ADD this CSS to your ConfirmModal.scss file:\n.cancellation-remark-section {\n  margin: 15px 0;\n  padding: 15px;\n  background: #fff8f0;\n  border-left: 4px solid #ff9800;\n  border-radius: 4px;\n  \n  label {\n    display: block;\n    font-weight: 600;\n    margin-bottom: 8px;\n    color: #333;\n  }\n  \n  .cancellation-remark-textarea {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-family: inherit;\n    font-size: 14px;\n    resize: vertical;\n    min-height: 60px;\n    box-sizing: border-box;\n    \n    &:focus {\n      outline: none;\n      border-color: #ff9800;\n      box-shadow: 0 0 0 2px rgba(255, 152, 0, 0.1);\n    }\n    \n    &::placeholder {\n      color: #888;\n    }\n  }\n}\n\n// Add this to your ConfirmModal.scss file\n\n.cancellation-remark-display {\n  margin-top: 15px;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n\n  strong {\n    color: #495057;\n    font-size: 14px;\n    display: block;\n    margin-bottom: 8px;\n  }\n\n  .remark-text {\n    margin: 0;\n    color: #6c757d;\n    font-size: 13px;\n    line-height: 1.4;\n    background: white;\n    padding: 8px 12px;\n    border-radius: 3px;\n    border: 1px solid #e9ecef;\n\n    &.no-remark {\n      font-style: italic;\n      color: #adb5bd;\n    }\n  }\n}\n\n.confirmation-modal {\n  background: #ffffff;\n  padding: 24px;\n  border-radius: 8px;\n  width: 700px;\n  max-width: 95%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  max-height: 85vh;\n  overflow-y: auto;\n  gap: 20px;\n  border: 1px solid #e5e7eb;\n  position: relative;\n\n  &.notinvoice{\n      width: 420px;\n\n      .branch-form-close-button {\n        top: 12px;\n      right: 12px;\n     }\n  }\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f3f4f6;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #d1d5db;\n    border-radius: 3px;\n  }\n\n  > p {\n    font-size: 18px;\n    color: #1f2937;\n    margin: 0;\n    line-height: 1.5;\n    font-weight: 600;\n    text-align: center;\n\n  }\n   .notinvoicep{\n      text-align: left;\n    }\n\n  .status-select {\n    width: 100%;\n    padding: 12px 16px;\n    border-radius: 8px;\n    border: 1px solid #d1d5db;\n    font-size: 14px;\n    font-weight: 500;\n    appearance: none;\n    background: #ffffff;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%236b7280' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    background-size: 16px;\n    cursor: pointer;\n    outline: none;\n    transition: border-color 0.2s ease;\n    color: #374151;\n\n    &:hover {\n      border-color: #6b7280;\n    }\n\n    &:focus {\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}\n\n.payment-section {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n\n  .section-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1f2937;\n    border-bottom: 2px solid #e5e7eb;\n    padding-bottom: 6px;\n    margin: 0;\n  }\n\n  .amount-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 14px;\n    color: #374151;\n    background: #f9fafb;\n    padding: 12px 16px;\n    border-radius: 8px;\n    font-weight: 600;\n    border: 1px solid #e5e7eb;\n\n    > div {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n\n      strong {\n        color: #1f2937;\n      }\n    }\n  }\n\n  .previous-payments {\n    background: #f9fafb;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n    \n    h4 {\n      margin: 0 0 12px 0;\n      padding: 12px 16px 0;\n      color: #374151;\n      font-size: 14px;\n      font-weight: 600;\n    }\n    \n    .payments-table-container {\n      max-height: 200px;\n      overflow-y: auto;\n      margin: 0 16px 16px;\n      border: 1px solid #e5e7eb;\n      border-radius: 6px;\n      background: white;\n      \n      &::-webkit-scrollbar {\n        width: 4px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #d1d5db;\n        border-radius: 2px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f3f4f6;\n      }\n    }\n    \n    .payments-table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: 12px;\n      margin: 0;\n      \n      th, td {\n        padding: 8px 10px;\n        text-align: left;\n        border-bottom: 1px solid #f3f4f6;\n      }\n      \n      th {\n        background: #f9fafb;\n        font-weight: 600;\n        color: #374151;\n        position: sticky;\n        top: 0;\n        z-index: 1;\n        font-size: 11px;\n      }\n      \n      td {\n        color: #6b7280;\n        background-color: white;\n        font-weight: 500;\n      }\n      \n      tr:hover td {\n        background: #f9fafb;\n      }\n\n      tr:last-child td {\n        border-bottom: none;\n      }\n\n      .download-receipt-btn {\n        background: #10b981;\n        color: white;\n        border: none;\n        border-radius: 4px;\n        padding: 4px 8px;\n        cursor: pointer;\n        font-size: 11px;\n        font-weight: 500;\n        transition: background-color 0.2s ease;\n        \n        &:hover {\n          background: #059669;\n        }\n        \n        &:active {\n          background: #047857;\n        }\n      }\n\n      th:nth-child(1), td:nth-child(1) { width: 15%; }\n      th:nth-child(2), td:nth-child(2) { width: 15%; }\n      th:nth-child(3), td:nth-child(3) { width: 12%; }\n      th:nth-child(4), td:nth-child(4) { width: 15%; }\n      th:nth-child(5), td:nth-child(5) { width: 15%; }\n      th:nth-child(6), td:nth-child(6) { width: 20%; }\n      th:nth-child(7), td:nth-child(7) { \n        width: 8%; \n        text-align: center;\n      }\n    }\n  }\n\n  .new-payment-form {\n    background: #f9fafb;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n    \n    h4 {\n      margin: 0 0 16px 0;\n      padding: 16px 16px 0;\n      color: #374151;\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    .payment-row {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 12px;\n      padding: 0 16px 16px;\n\n      .pay-form-group {\n        display: flex;\n        flex-direction: column;\n\n        label {\n          font-size: 12px;\n          color: #374151;\n          margin-bottom: 4px;\n          font-weight: 600;\n        }\n\n        select,\n        input {\n          padding: 8px 12px;\n          border: 1px solid #d1d5db;\n          border-radius: 6px;\n          font-size: 13px;\n          font-weight: 500;\n          width: 100%;\n          box-sizing: border-box;\n          transition: border-color 0.2s ease;\n          background: #ffffff;\n          color: #374151;\n\n          &:hover {\n            border-color: #6b7280;\n          }\n\n          &:focus {\n            border-color: #3b82f6;\n            outline: none;\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n          }\n\n          &:disabled {\n            background: #f3f4f6;\n            color: #9ca3af;\n            cursor: not-allowed;\n          }\n\n          &::placeholder {\n            color: #9ca3af;\n          }\n        }\n\n        select {\n          appearance: none;\n          background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%236b7280' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'/%3E%3C/svg%3E\");\n          background-repeat: no-repeat;\n          background-position: right 8px center;\n          background-size: 12px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n\n.confirmation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n\n  &.notinvoice{\n    border-top: none;\n  }\n\n  .confirm-btn,\n  .cancel-btn {\n    padding: 8px 18px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 80px;\n  }\n\n  .confirm-btn {\n    background:var(--primary-color);\n    color: white;\n\n    &:hover {\n      background: var(--primary-color);\n    }\n\n  }\n\n  .cancel-btn {\n    background: #6b7280;\n    color: white;\n\n    &:hover {\n      background: #4b5563;\n    }\n\n    &:active {\n      background: #374151;\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .confirmation-modal {\n    width: 95%;\n    padding: 20px;\n    gap: 16px;\n\n    > p {\n      font-size: 16px;\n    }\n\n    .payment-section {\n      gap: 14px;\n\n      .amount-info {\n        flex-direction: column;\n        gap: 4px;\n        text-align: center;\n        font-size: 13px;\n      }\n\n      .previous-payments .payments-table {\n        font-size: 10px;\n        \n        th, td {\n          padding: 6px 4px;\n        }\n        \n        .download-receipt-btn {\n          padding: 3px 6px;\n          font-size: 9px;\n        }\n      }\n\n      .new-payment-form .payment-row {\n        grid-template-columns: 1fr;\n        gap: 10px;\n\n        .pay-form-group {\n          select,\n          input {\n            padding: 10px 12px;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n\n    .confirmation-actions {\n      .confirm-btn,\n      .cancel-btn {\n        flex: 1;\n        padding: 12px 16px;\n      }\n    }\n  }\n}\n\n.branch-form-close-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    z-index: 1001;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: #f3f4f6;\n      color: #374151;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
